'use strict';

import Handlebars from 'injectify/runtime';
import {isFeatureActive} from './ifFeature';


Handlebars.registerHelper('t', function (key) {

    if (isFeatureActive('LOKALISE_INPLACE_EDIT')) {
        window.__ = (key) => `{.${key}.}`;

        return `{.${key}.}`;
    }

    let regex = /<[a-z][\s\S]*>/i;
    let value = __(key);

    if (regex.test(value)) {
        return new Handlebars.SafeString(value);
    } else {
        return value;
    }
});



// WEBPACK FOOTER //
// ./shared/helper/t.js